/**
 * Detect if the current page is under the jeunesse section (which we legally can't track).
 * Should not happen anymore since another GTM container is used in the Jeunesse section...
 * But better safe than legal proceedings!
 */
export function isPageJeunesse(): boolean {
  const path = window.location.pathname.toLowerCase();
  return path.startsWith("/jeunesse");
}

/**
 * Page where a user can change is personal info (first name, last name, email, etc.)
 * This page / app isn't worth tracking and may be out-of-date.
 */
export function isPageMonCompte(): boolean {
  const hostName = window.location.hostname.toLowerCase();
  return hostName.indexOf("mon-compte.radio-canada.ca") !== -1;
}

/**
 * Check if the URL of the current page match the URL of the page where the browser is redirected after a
 * successful login.
 */
export function isMemberCenterCallback(): boolean {
  const path = window.location.pathname.toLowerCase();
  // Note: on Mordu, the redirection is made to mordu/callback/membercenter, but there are no redirections after that.
  // Therefore, I want to exclude the path only for DotCa.
  return path.startsWith("/callback/membercenter");
}

/**
 * Check if the current page is part of the Radio-Canada International (RCI) website.
 */
export function isCurrentSiteRci(): boolean {
  const path = window.location.pathname.toLowerCase();
  return path === "/rci" || path.startsWith("/rci/");
}

export function isCurrentSiteExternal(): boolean {
  return dataLayerHelper.get<string>("page.VersionProjet")?.toLowerCase() === "siteexterne";
}
